import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { map, catchError, retry } from 'rxjs/operators';
import { Event } from '../models/event';

@Injectable({
	providedIn: 'root'
})

export class EventService {

	constructor(private http: HttpClient, private authService: AuthService) { }

	getEvent(eventGuid: string): Promise<Observable<Event>> {
		return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {

			let eventApiUrl = ConfigService.APP_SECURITY_API_ENDPOINT + "event/event-v1";
			
			let eventApiUrl_inline: string = `${eventApiUrl}?eventGuid=${eventGuid}`;
			
			// make http get request
			return this.http.get<Event[]>(eventApiUrl_inline, { headers: contentHeaders }).pipe(
				retry(3), // retry a failed request up to 3 times
				catchError(this.handleError),//this.handleError), // then handle the error
				map(res => res['objectdata']) // on success, data is within 'objectdata' in json
			);	
		});
	}

	getEventsTimeStamp(storeGuid: string, startTime: Date, endTime: Date, skip: number, take: number, sortField: string, sortOrder: string): Promise<Observable<any>> {
		return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {

			let eventApiUrl = ConfigService.APP_SECURITY_API_ENDPOINT + "event/events-v1";
		
			// NOTE: Backend failed to recognize storeGuid in headers. Must resort to inline method
			//contentHeaders = contentHeaders.append("storeGuid", storeGuid);
			let eventApiUrl_inline: string = `${eventApiUrl}?storeGuid=${storeGuid}&startTime=${startTime.toISOString()}&endTime=${endTime.toISOString()}&skip=${skip}&take=${take}&sortField=${sortField}&sortOrder=${sortOrder}`;
			
			// make http get request
			return this.http.get<Event[]>(eventApiUrl_inline, { headers: contentHeaders }).pipe(
				retry(3), // retry a failed request up to 3 times
				catchError(this.handleError),//this.handleError), // then handle the error
				map(res => { return { history: res['eventHistory'], count: res['count'] } } ) // on success, data is within 'eventHistory' in json
			);	
		});
	}

	getEvents(storeGuid: string): Promise<Observable<any>> {
		return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {

			let eventApiUrl = ConfigService.APP_SECURITY_API_ENDPOINT + "event/events-v1";
			
			let eventApiUrl_inline: string = `${eventApiUrl}?storeGuid=${storeGuid}`;
			
			// make http get request
			return this.http.get<Event[]>(eventApiUrl_inline, { headers: contentHeaders }).pipe(
				retry(3), // retry a failed request up to 3 times
				catchError(this.handleError),//this.handleError), // then handle the error
				map(res => { return { history: res['eventHistory'], count: res['count'] } } ) // on success, data is within 'eventHistory' in json
			);	
		});
	}

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error('An error occurred:', error.error.message);
		} 
		else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong,
			console.error(
				`Backend returned code ${error.status}, ` +
				`body was: ${error.error}`);

			// return an observable with a user-facing error message
			return throwError('Unable to fetch Events; Error code ' + error.status + ' (' + error.statusText + ')');
		}
		// return an observable with a user-facing error message
		return throwError('Unable to fetch Events; please try again later.');
	};
}
